<template>
  <PageTitleComponent />
  <div class="login">
    <div class="login__logo">
      <AixamTvComponent />
    </div>
    <div class="login__title">Votre code / Your code</div>
    <div class="login__code">{{ code }}</div>
    <div class="login__info">
      Pour connecter votre TV, veuillez vous rendre sur votre compte sur le
      Portail Aixam. Dans votre profil, cliquer sur ajouter une TV et renseigner
      le code ci-dessus.
    </div>
    <div class="login__line"></div>
    <div class="login__info">
      To connect to your TV, go to your account on the Aixam Portal. In your
      profile, click on add a TV and enter the code above.
    </div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import { loginManager } from "@/services/login-manager";
import AixamTvComponent from "@/components/AixamTvComponent.vue";
import { mapState } from "pinia";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "LoginView",
  methods: { getTranslation },
  components: { AixamTvComponent, PageTitleComponent },
  computed: {
    ...mapState(useMainStore, {
      code: (store) => store.code,
    }),
  },
  mounted() {
    loginManager.watchLogin();
    if (
      localStorage.getItem("aixam-login") &&
      localStorage.getItem("aixam-private-key")
    ) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $white;
  height: 100%;
  width: 100%;

  &__logo {
    margin-bottom: 55px;
  }

  &__title {
    font-size: 28px;
  }

  &__code {
    font-size: 90px;
    font-weight: 700;
    letter-spacing: 10px;
    line-height: 1;
    margin-bottom: 80px;
  }

  &__info {
    font-size: 18px;
    max-width: 750px;
    text-align: center;
  }

  &__line {
    position: relative;
    width: 100%;
    margin: 25px 0;

    &:before {
      content: "";
      background: $white;
      width: 120px;
      height: 1px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
  }
}
</style>
